import { useState, useEffect, useCallback } from 'react';

/**
 * Tracks an element's content width via ResizeObserver.
 * Returns a callback ref so remounts (e.g. list ↔ detail) re-attach cleanly.
 * @returns {[setEl: (el: HTMLElement|null) => void, width: number]}
 */
export function useElementWidth() {
  const [node, setNode] = useState(null);
  const [width, setWidth] = useState(0);
  const ref = useCallback((el) => {
    setNode(el);
  }, []);

  useEffect(() => {
    if (!node || typeof ResizeObserver === 'undefined') {
      setWidth(0);
      return undefined;
    }

    const update = () => setWidth(Math.round(node.getBoundingClientRect().width));
    update();

    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width;
      if (typeof w === 'number') setWidth(Math.round(w));
    });
    ro.observe(node);
    return () => ro.disconnect();
  }, [node]);

  return [ref, width];
}
